import PasswordReset from './PasswordReset'
import SignIn from './SignIn'
import SignUp from './SignUp'

export default {
  PasswordReset,
  SignIn,
  SignUp
}
